// Message center component
import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { 
  ChatBubbleLeftRightIcon,
  PaperAirplaneIcon 
} from '@heroicons/react/24/outline';

const MessageCenter = () => {
  const { user } = useAuth();
  const [messages] = useState([
    {
      id: 1,
      from: 'Admin',
      message: 'Welcome to the client portal! Your case has been updated.',
      timestamp: new Date(Date.now() - 86400000), // 1 day ago
      read: true
    },
    {
      id: 2,
      from: 'Legal Team',
      message: 'Please review the documents uploaded to your case.',
      timestamp: new Date(Date.now() - 172800000), // 2 days ago
      read: false
    }
  ]);
  
  const [newMessage, setNewMessage] = useState('');

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (newMessage.trim()) {
      // Here you would typically send the message to the backend
      console.log('Sending message:', newMessage);
      setNewMessage('');
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:px-6 border-b border-gray-200">
          <div className="flex items-center">
            <ChatBubbleLeftRightIcon className="h-8 w-8 text-primary-600 mr-3" />
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Message Center</h1>
              <p className="mt-1 text-sm text-gray-600">
                Communicate with your legal team
              </p>
            </div>
          </div>
        </div>

        <div className="p-6">
          {/* Messages List */}
          <div className="space-y-4 mb-6 max-h-96 overflow-y-auto">
            {messages.map((message) => (
              <div
                key={message.id}
                className={`p-4 rounded-lg ${
                  message.read ? 'bg-gray-50' : 'bg-blue-50 border-l-4 border-blue-400'
                }`}
              >
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <div className="flex items-center mb-2">
                      <span className="font-medium text-gray-900">{message.from}</span>
                      {!message.read && (
                        <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                          New
                        </span>
                      )}
                    </div>
                    <p className="text-gray-700">{message.message}</p>
                  </div>
                  <span className="text-sm text-gray-500 ml-4">
                    {message.timestamp.toLocaleDateString()}
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* Send Message Form */}
          <form onSubmit={handleSendMessage} className="border-t pt-6">
            <div className="flex space-x-4">
              <div className="flex-1">
                <label htmlFor="message" className="sr-only">
                  Your message
                </label>
                <textarea
                  id="message"
                  rows={3}
                  className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-500 focus:border-primary-500"
                  placeholder="Type your message..."
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                />
              </div>
              <div className="flex-shrink-0">
                <button
                  type="submit"
                  className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                >
                  <PaperAirplaneIcon className="h-5 w-5" />
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default MessageCenter;